<template>
  <div class="d-flex h-100 padding">
    <div class="d-flex flex h-100 block m-0">
      <div class="fade aside aside-sm" id="content-aside">
        <div class="modal-dialog d-flex flex-column w-md b-r bg-white" id="mail-nav">
          <div class="navbar">
            <span>{{ $t('message.Book.bookList') }}</span>
          </div>
          <div class="scrollable hover">
            <div class="p-2 px-3">

              <button class="btn btn-sm btn-block btn-rounded bg-primary-lt i-con-h-a" @click.prevent.stop="$router.push({name: 'BookCreate'})">
                <i class="i-con i-con-plus float-left w-16"></i>
                Buch hinzufügen
              </button>
            </div>
            <div class="sidenav my-3">
              <nav class="nav-active-text-primary" data-nav>
                <ul class="nav">

                  <li class="nav-header d-flex">
                    <div class="py-2 text-muted">{{ $t('message.Book.categories') }} (in progress)</div>
                    <span class="flex"></span>
                  </li>

                  <li v-for="(category, idx) in categories">
                    <a href="app.mail.html#html5" @click.prevent="categoryFilter(category.id)" class="link">
                      <span class="nav-badge">
                        <b class="badge badge-circle mx-1" :class="{'active': catIdsFilter == category.id, 'text-primary': idx==0, 'text-primary': idx%2, 'text-success': idx%2}"></b>
                      </span>
                      <span class="nav-text name">{{ category.name }}</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

          </div>
          <div v-if="false" class="px-3 pb-3 pt-2  mt-auto b-t">
            <small class="text-muted">Usage: 35%</small>
            <div class="progress mt-2" style="height:3px;">
              <div class="progress-bar bg-warning" style="width: 35%"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="aside-deck hide" id="mail-deck">
        <div class="card card-origin alert p-0 m-0 b-a hide">
          <div class="card-header d-flex align-items-center bg-body">
            <div class="flex h-1x mx-1 mail-to">New mail</div>
            <div class="ml-auto no-wrap">
              <button class="btn btn-sm btn-link btn-icon no-shadow i-con-h-a" data-toggle="tooltip" data-placement="top" title="Send">
                <span>
                  <i class="i-con i-con-arrow-right"><i></i></i>
                </span>
              </button>
              <button class="btn btn-sm btn-link btn-icon no-shadow text-muted i-con-h-a" data-toggle-class="card-hide-body" data-target=".card" data-target-closest="true">
                <i class="i-con i-con-minus"></i>
              </button>

              <button class="btn btn-sm btn-link btn-icon no-shadow text-muted i-con-h-a" data-dismiss="alert">
                <i class="i-con i-con-close"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <form>
              <div class="mb-2">
                <input type="text" class="form-control" placeholder="Recipients">
              </div>
              <div>
                <input type="text" class="form-control" placeholder="Subject">
              </div>
              <div class="note-editor-inline">
                <textarea class="form-control summernote">
                </textarea>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="d-flex flex" id="content-body">
        <div class="d-flex flex-column flex" id="mail-list" data-plugin="mail">
          <div class="p-3 b-b">
            <div class="toolbar ">
              <form class="flex">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm search" placeholder="Suche" v-debounce:300ms="onSearch">
                  <span class="input-group-append">
                <button class="btn btn-white no-shadow btn-sm i-con-h-a" type="button">
                  <i class="i-con i-con-search text-muted"></i>
                </button>
                </span>
                  <button class="btn btn-sm btn-rounded bg-primary-lt i-con-h-a ml-2" id="btn-new-mail" @click.prevent.stop="$router.push({name: 'BookCreate'})">
                    <i class="i-con i-con-plus float-left w-16"></i>
                    Buch hinzufügen
                  </button>
                </div>
              </form>
              <button data-toggle="modal" data-target="#content-aside" data-modal class="btn btn-sm btn-white d-md-none i-con-h-a">
                <i class="i-con i-con-nav text-muted"><i></i></i>
              </button>
            </div>
          </div>
          <div class="scroll-y p-3 h-100">

            <div v-if="showData == false" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>
            <b-table v-else striped hover :items="filteredBooks" :fields="list_fields">
              <template slot="title" slot-scope="data">
                <span class="title-column">{{data.value}}</span>
              </template>

              <template slot="publisher" slot-scope="data">
                <span class="title-column">{{ data.value.name }}</span>
              </template>

              <template slot="categories" slot-scope="data">
                <template v-for="item in data.value">
                  <b-badge :style="{'background-color': getCategoryColor(item.name)}" class="mr-1">{{item.name}}</b-badge>
                </template>
                <!--<comma-separated-span :list="data.value" :field="'name'"></comma-separated-span>-->
              </template>
              <template slot="actions" slot-scope="data">
                <div class="action-button-container d-flex">

                  <button class="btn btn-sm btn-white i-con-h-a mr-2"
                      data-toggle="tooltip"
                      v-b-tooltip.hover
                      title="Anzeigen"
                      @click="$router.push('/books/' + data.item.id + '/view')"
                  >
                    <i class="i-con i-con-eye text-muted"><i></i></i>
                  </button>

                  <button 
                    class="btn btn-sm btn-white i-con-h-a mr-2" 
                    data-toggle="tooltip" 
                    v-b-tooltip.hover 
                    title="Bearbeiten"
                    @click="$router.push('/books/' + data.item.id + '/edit')">
                    <i class="i-con i-con-edit text-muted"><i></i></i></button>

                </div>
              </template>
            </b-table>
          </div>
          <div class="p-3 b-t mt-auto">
            <div class="d-flex align-items-center">
              <div class="flex d-flex flex-row">
                <a href="#" class="btn btn-xs white no-border pager-prev hide">
                  <i class="fa fa-angle-left"></i>
                </a>
                <div class="pagination pagination-xs">
                </div>
                <a href="#" class="btn btn-xs white no-border pager-next hide">
                  <i class="fa fa-angle-right"></i>
                </a>
              </div>
              <div>
                <span class="text-muted">{{ $t('message.total') }}:</span>
                <span id="count"> {{ filteredBooks.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CommaSeparatedSpan from '@/components/CommaSeparatedSpan/CommaSeparatedSpan';
  import { mapGetters } from 'vuex'

  export default {
    name: "BookList",

    components: {
      CommaSeparatedSpan
    },

    data() {

      return {
        showData: false,
        searchValue: null,
        categoryColors: [],
        catIdsFilter: null,
        list_fields: [
          'id',
          {
            key: 'title',
            label: 'Buchtitel',
            sortable: true
          },
          {
            key: 'publisher',
            label: 'Verlag',
            sortable: true,
          },
          {
            key: 'categories',
            label: 'Kategorien'
          },
          'actions'
        ],
      }
    },

    mounted() {
      if (this.booksLoaded) {
        this.showData = true
      } else {
        setTimeout(() => {
          this.showData = true
        }, 1500)
      }
    },

    computed: {
      //https://medium.com/aviabird/rxjs-reducing-number-of-api-calls-to-your-server-using-debouncetime-d71c209a4613
      filteredBooks() {
        if (this.searchValue && this.searchValue.length > 2) {
          const s = this.searchValue.toLowerCase();
          return this.books.filter(x => {
            if (x.title.toLowerCase().indexOf(s) !== -1) {
              return true;
            }

            if (x.publisher && x.publisher.name && x.publisher.name.toLowerCase().indexOf(s) !== -1) {
              return true;
            }

            if (this.catIdsFilter && x.category_ids.indexOf(this.catIdsFilter) !== -1) {
              return true;
            }

            return false;
          });
        } else {
          if (this.catIdsFilter) {
            return this.books.filter(x => {
              if (this.catIdsFilter && x.category_ids.indexOf(this.catIdsFilter) !== -1) {
                return true;
              }

              return false;
            });
          }

          return this.books;
        }
      },
    },

    methods: {
      onSearch(value) {
        this.searchValue = value;
      },

      categoryFilter(id) {
        if (this.catIdsFilter === id) {
          return this.catIdsFilter = null;
        }

        this.catIdsFilter = id;
      },

      getCategoryColor(categoryName) {
        if (this.categoryColors.length === 0) {
          const cats = this.books.flatMap(x => x.categories.map(xx => xx.name));
          const uniqueCats = [...new Set(cats)];

          uniqueCats.forEach(x => {
             this.categoryColors.push({name: x, color: '#'+Math.random().toString(16).substr(-6)})
          });
        }

        return this.categoryColors.filter(x => x.name === categoryName)[0].color;
      }
    }
  }
</script>

<style scoped>
  .title-column {
    font-weight: bold;
  }

  .badge-circle.active{
    background: red;
  }
</style>
